import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as homePageActions from "../../actions/homePageActions";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import Details from "./details";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PropTypes from "prop-types";

const Index = (props) => {
  const { actions, homePageData, advisors, teams } = props;

  const Members = {
    dots: false,
    infinite: true,
    centerpadding: 0,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const prepareHtml = (description = "") => ({
    __html: description,
  });

  useEffect(() => {
    const fetchData = () => {
      actions.loadHomePageData("about-us");
      actions.loadLeaderData(4);
    };
    fetchData();
  }, []);

  useEffect(() => {
    document.title = homePageData.meta_title;
    document.querySelector('meta[name="description"]').setAttribute('content', homePageData.meta_description);
  });

  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});

  const getUserDetails = (
    e, {
      full_name,
      image,
      organization,
      position,
      about,
      linkedin,
      main_area
    }) => {
    e.preventDefault();
    setModalShow(true);
    setUserData({
      full_name: full_name,
      image: image,
      organization: organization,
      position: position,
      about: about,
      linkedin: linkedin,
      main_area: main_area,
    });
  };

  return (
    <>
      <section className="about_content_mian aboutclass">
        <Container>
          <div className="about_content">
            <h1 className="title">Passionate about diversity by helping women grow and lead </h1>
            <p>We’re a group of experienced diversity champions across domains united by one mission: nurturing more women talent pools across businesses by breaking access barriers. vLookUp started in July 2021 and we’ve seen it grow significantly in a short time. Our mentors come from across 13 industries, nearly 70 organizations, over 10 countries, and currently 35% of them are men. Our mentees come from 12 countries and 60+ organizations. We have enabled 1000+ hours of meaningful mentoring engagement for our members in one year.<br />Our offerings have expanded and now we provide an AI enabled integrated mentoring process and platform to complement the D&I initiatives of organizations. <a href="/partnerships">Read about how vLookUp can support yours. </a></p>

          </div>
        </Container>
        <section className="about_content_mian">
          <div className="container">
            <div className="about_content">
              <div className="title">Our Dream</div>
              <p className="m-0">Many of us experience having a mentor for the first time almost mid-way through our careers, realize the positive impact and wonder why we didn’t look for one earlier. Many others don’t know where to look, especially if they want to speak to someone outside their organization. There are fewer women in the labor force, and in leadership. And with the many transitions we go through in our professional careers and lives, the right role models, right access, and domain-specific mentoring can make a difference. We are passionate about creating this support structure, right from the early days of one’s career, so women can stay, grow, and lead. </p>

            </div>
          </div>
        </section>
      </section>
      <div
        dangerouslySetInnerHTML={prepareHtml(homePageData.description)}
      ></div>

      <section className="about_who_sec">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <div className="about_content">
                <div className="title">Meet the team</div>
                <p className="m-0">
                  We are committed diversity champions who truly believe in the power of diverse workplaces
                </p>
              </div>
            </Col>

            <Col md={6}>
              <Row className="who-thumb-outer">
                {teams?.map((item, key) => (
                  <Col
                    md={6} key={item.id || item.full_name}
                    className={(key === 1 || key === 3) && "mt-md-n5"}
                  >
                    <div className="who_box" key={item.id}>
                      <img className="w-100" src={item.image} alt={item.full_name} />
                      <div className="who_info text-left">
                        <div className="hover-part">
                          <p className="positionsh">{item.position}</p>
                          <span className="profile">{item.full_name}</span>
                          <div className="hvrcontant">

                            <p>{item.organization}</p>
                            <Link
                              to={{ pathname: item.linkedin_url }}

                              className="newcustomelinked text-white m-0"

                              target="_blank"
                            >
                              Linkedin Profile
                            </Link>
                            <div>
                              <button
                                type="button"
                                className="readmore btn btn-link p-0"
                                onClick={(e) => getUserDetails(e, item)}
                              >
                                Read More <i className="fas fa-long-arrow-alt-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="members_sec">
        <Container>
          <div className="title text-center space-bottom">
            Our Advisors
          </div>

          <Slider {...Members}>
            {advisors?.map((item, key) => (
              <div key={item.id || item.full_name}>
                <div className="member_box text-center">
                  <div className="member_img">
                    <img src={item.image} alt={item.full_name} />
                    <div className="advisor-contnt">
                      <p className="positionsh">{item.position}</p>
                      <span className="name d-block pt-2">{item.full_name}</span>
                      <div className="hvrcontant">

                        <p>{item.organization}</p>
                        <Link
                          to={{ pathname: item.linkedin_url }}

                          className="newcustomelinked text-white m-0"

                          target="_blank"
                        >
                          Linkedin Profile
                        </Link>
                        <div>
                          <button
                            type="button"
                            className="readmore btn btn-link p-0"
                            onClick={(e) => getUserDetails(e, item)}
                          >
                            Read More <i className="fas fa-long-arrow-alt-right"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </Container>
        {modalShow && (
          <Details
            show={modalShow}
            userdata={userData}
            onHide={() => setModalShow(false)}
            centered
            size="xl"
            className="mentor_modal"
          />
        )}
      </section>
    </>
  );
};

Index.propTypes = {
  actions: PropTypes.shape({
    loadHomePageData: PropTypes.func.isRequired,
    loadLeaderData: PropTypes.func.isRequired,
  }).isRequired,

  setting: PropTypes.shape({
    name: PropTypes.string,
    module_data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        status: PropTypes.string,
        is_default: PropTypes.string,
      })
    ),
  }).isRequired,

  homePageData: PropTypes.shape({
    description: PropTypes.string,
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
  }).isRequired,

  advisors: PropTypes.arrayOf(
    PropTypes.shape({
      full_name: PropTypes.string,
      image: PropTypes.string,
      organization: PropTypes.string,
      position: PropTypes.string,
      about: PropTypes.string,
      linkedin_url: PropTypes.string,
      main_area: PropTypes.string,
      length: PropTypes.number,
      map: PropTypes.func,
    })
  ).isRequired,

  teams: PropTypes.arrayOf(
    PropTypes.shape({
      full_name: PropTypes.string,
      image: PropTypes.string,
      organization: PropTypes.string,
      position: PropTypes.string,
      about: PropTypes.string,
      linkedin_url: PropTypes.string,
      main_area: PropTypes.string,
      length: PropTypes.number,
      map: PropTypes.func,
    })
  ).isRequired,
};

function mapStateToProps(state) {
  return {
    homePageData: state.homePageData,
    leaders: state.leaders,
    teams: state.teams,
    advisors: state.advisors,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...homePageActions,
    },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
